import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

interface Props {
    active?: boolean
    border?: string
    borderActive?: string
    borderRadius?: string
    background?: string
    padding?: string
    boxShadow?: string
    boxShadowActive?: string
    width?: string
    height?: string
    outline?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContainerBox',
  props: {
    active: { type: Boolean },
    border: {},
    borderActive: {},
    borderRadius: {},
    background: {},
    padding: {},
    boxShadow: {},
    boxShadowActive: {},
    width: {},
    height: {},
    outline: {}
  },
  setup(__props: any) {

const props = __props

const boxStyle = computed(() => {
    return {
        border: props.active ? props.borderActive : props.border,
        borderRadius: props.borderRadius,
        background: props.background,
        padding: props.padding,
        width: props.width,
        height: props.height,
        boxShadow: props.active ? props.boxShadowActive : props.boxShadow,
        outline: props.outline,
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(boxStyle.value),
    class: _normalizeClass(["tf-container-box bg-primary-white", props.active && 'active'])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})